<template>
  <div class="vdatetime-calendar">
    <div class="vdatetime-calendar__navigation">
      <div class="vdatetime-calendar__navigation--previous" @click="previousMonth">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61.3 102.8">
          <path fill="none" stroke="#444" stroke-width="14" stroke-miterlimit="10" d="M56.3 97.8L9.9 51.4 56.3 5"/>
        </svg>
      </div>
      <div class="vdatetime-calendar__current--month">{{ monthName }} {{ newYear }}</div>
      <div class="vdatetime-calendar__navigation--next" @click="nextMonth">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61.3 102.8">
          <path fill="none" stroke="#444" stroke-width="14" stroke-miterlimit="10" d="M56.3 97.8L9.9 51.4 56.3 5"/>
        </svg>
      </div>
    </div>
    <div class="vdatetime-calendar__month">
      <div class="vdatetime-calendar__month__weekday" v-for="(weekday,index) in weekdays" :key="index + 1">
        <span>{{ weekday }}</span>
      </div>
      <div class="vdatetime-calendar__month__day" v-for="(day,index) in days" :key="index + 100" @click="selectDay(day)" :class="[
      {'vdatetime-calendar__month__day--selected': day.selected},
      {'vdatetime-calendar__month__day--disabled': day.disabled}]">
        <span><span>{{ day.number }}</span></span>
      </div>
    </div>
  </div>
</template>

<script>
import { DateTime } from './luxon/src/luxon.js'
// import { monthDayIsDisabled, monthDays, months, weekdays } from './util.js'
import { monthDayIsDisabled as util_MonthDayIsDisabled, monthDays as util_MonthDays, months as util_Months, weekdays as util_Weekdays } from './util.js'

export default {
  props: {
    year: {
      type: Number,
      required: true
    },
    month: {
      type: Number,
      required: true
    },
    day: {
      type: Number,
      default: null
    },
    disabled: {
      type: Array
    },
    minDate: {
      type: DateTime,
      default: null
    },
    maxDate: {
      type: DateTime,
      default: null
    },
    weekStart: {
      type: Number,
      default: 1
    }
  },

  data () {
    return {
      newDate: DateTime.fromObject({ year: this.year, month: this.month, timeZone: 'UTC' }),
      weekdays: util_Weekdays(this.weekStart),
      // months: util_Months(),
      months: ["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"]
    }
  },
  mounted(){
    this.weekToCN();
    this.monthToCN();
  },
  computed: {
    newYear () {
      return this.newDate.year
    },
    newMonth () {
      return this.newDate.month
    },
    monthName () {
      return this.months[this.newMonth - 1]
    },
    days () {
      return util_MonthDays(this.newYear, this.newMonth, this.weekStart).map(day => ({
        number: day,
        selected: day && this.year === this.newYear && this.month === this.newMonth && this.day === day,
        disabled: !day || util_MonthDayIsDisabled(this.minDate, this.maxDate, this.newYear, this.newMonth, day)
      }))
    }
  },

  methods: {
    selectDay (day) {
      if (day.disabled) {
        return
      }

      this.$emit('change', this.newYear, this.newMonth, day.number)
    },
    previousMonth () {
      this.newDate = this.newDate.minus({ months: 1 })
    },
    nextMonth () {
      this.newDate = this.newDate.plus({ months: 1 })
    },
    //星期名称转换中文
    weekToCN(){
      for(let i=0; i<this.weekdays.length; i++){
        let newWeekDay = this.weekdays[i].replace("Mon","周一").replace("Tue","周二").replace("Wed","周三").replace("Thu","周四").replace("Fri","周五").replace("Sat","周六").replace("Sun","周日");
        this.weekdays.splice(i,1,newWeekDay);
      }
    },
    //月份名称转换中文
    monthToCN(){
      for(let i=0; i<this.months.length; i++){
        let newMonth = this.months[i].replace("January","一月").replace("February","二月").replace("March","三月").replace("April","四月").replace("May","五月").replace("June","六月").replace("July","七月");
        newMonth = newMonth.replace("August","八月").replace("September","九月").replace("October","十月").replace("November","十一月").replace("December","十二月");
        this.months.splice(i,1,newMonth);
      }
    }
  }
}
</script>

<style>
.vdatetime-calendar__navigation,
.vdatetime-calendar__navigation * {
  box-sizing: border-box;
}

.vdatetime-calendar__navigation {
  position: relative;
  margin: 15px 0;
  padding: 0 30px;
  width: 100%;
}

.vdatetime-calendar__navigation--previous,
.vdatetime-calendar__navigation--next {
  position: absolute;
  top: 0;
  padding: 0 5px;
  width: 18px;
  cursor: pointer;
}
.vdatetime-calendar__navigation--previous svg,
.vdatetime-calendar__navigation--next svg{
  width: 8px;
}
.vdatetime-calendar__navigation--previous svg path,
.vdatetime-calendar__navigation--next svg path{
  transition: stroke .3s;
}
.vdatetime-calendar__navigation--previous:hover svg path,
.vdatetime-calendar__navigation--next:hover svg path{
  stroke: #888;
}

.vdatetime-calendar__navigation--previous {
  left: 25px;
}

.vdatetime-calendar__navigation--next {
  right: 25px;
  transform: scaleX(-1);
}

.vdatetime-calendar__current--month {
  text-align: center;
  text-transform: capitalize;
}

.vdatetime-calendar__month {
  padding: 0 20px;
  transition: height .2s;
  margin: 0 auto;
}

.vdatetime-calendar__month__weekday,
.vdatetime-calendar__month__day {
  display: inline-block;
  width: calc(100% / 7);
  /* flex: 0 0 auto;
  width: 14.28%;
  height: 0;
  padding-top: 14.28%;
  position: relative; */
  min-height: 36px;
  line-height: 36px;
  text-align: center;
  font-size: 15px;
  font-weight: 300;
  cursor: pointer;
}
.vdatetime-calendar__month__weekday > span,
.vdatetime-calendar__month__day > span {
    display: block;
    width: 100%;
    position: relative;
    height: 0;
    padding: 0 0 100%;
    overflow: hidden;
    /* width: 100%;
    height: 100%;
    padding: 0;
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center; */
}
.vdatetime-calendar__month__weekday > span > span,
.vdatetime-calendar__month__day > span > span {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border: 0;
  border-radius: 50%;
  transition: background-color .3s, color .3s;
}

.vdatetime-calendar__month__weekday {
  font-weight: bold;
}

.vdatetime-calendar__month__day:hover > span > span {
  background: #eee;
}

.vdatetime-calendar__month__day--selected > span > span,
.vdatetime-calendar__month__day--selected:hover > span > span {
  color: #fff;
  background: #3f51b5;
}

.vdatetime-calendar__month__day--disabled {
  opacity: 0.4;
  cursor: default;
}
.vdatetime-calendar__month__day--disabled:hover > span > span {
  color: inherit;
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/shared/libs/vue-datetime/DatetimeCalendar.vue